import { IStatusCodeDTO } from "../../../index";
import Utils from "../../util/Utils";
import { IStatusCode } from "./index";

export default class StatusCode implements IStatusCode {
  private _id: number;
  private _code: string;
  private _initDesc: string;
  private _additionalDesc: string;

  constructor(args?: IStatusCodeDTO) {
    this._id = Utils.default(args?.id, 0);
    this._code = Utils.default(args?.code, "");
    this._initDesc = Utils.default(args?.initDesc, "");
    this._additionalDesc = Utils.default(args?.additionalDesc, "");
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get initDesc(): string {
    return this._initDesc;
  }

  set initDesc(value: string) {
    this._initDesc = value;
  }

  get additionalDesc(): string {
    return this._additionalDesc;
  }

  set additionalDesc(value: string) {
    this._additionalDesc = value;
  }
}
